<template>
  <div class="cvux-check-icon" @click="updateValue">
    <icon type="success" v-show="type === 'default' && value"></icon>
    <icon type="success-circle" v-show="type === 'plain' && value"></icon>
    <icon type="circle" v-show="!value"></icon>
    <span><slot></slot></span>
  </div>
</template>
<script>
  import Icon from '../icon'
  export default {
    name: 'check-icon',
    components: {
      Icon
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'default'
      }
    },
    methods: {
      updateValue() {
        this.$emit('update:value', !this.value)
      }
    }
  }
</script>
<style lang="less">
  @pre: cvux;
  @{pre}-check-icon{

  }

</style>



// WEBPACK FOOTER //
// checkIcon.vue?d0221284